import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { UncontrolledTooltip } from 'reactstrap';

const propTypes = {
  onClick: PropTypes.func.isRequired,
  isRead: PropTypes.any,
  id: PropTypes.string.isRequired,
};

const handleClick = (e, callback) => {
  e.preventDefault();
  e.stopPropagation();
  callback();
};

const renderIcon = (isRead, id) => {
  return isRead ?
    <span>
      <FontAwesomeIcon
        icon={["far", "circle"]}
        id={`mar_${id}`}
      />
      <UncontrolledTooltip target={`mar_${id}`}>Mark as Unread</UncontrolledTooltip>
    </span>
  :
    <span>
      <FontAwesomeIcon
        icon={["fas", "circle"]}
        id={`mar_${id}`}
      />
      <UncontrolledTooltip target={`mar_${id}`}>Mark as Read</UncontrolledTooltip>
    </span>;
};

const MarkAsRead = ({ onClick, isRead, id }) => {
  return (
    <span
      onClick={(e) => handleClick(e, onClick)}
      className="MarkAsRead"
    >
      {renderIcon(isRead, id)}

    </span>
  );
};

MarkAsRead.propTypes = propTypes;

export default MarkAsRead;



// WEBPACK FOOTER //
// ./src/features/dashboard/MarkAsRead.js